import React, { PropTypes } from 'react';
import '../../styles/ReliabilityObservationSetup';
import Preferences from '../lib/preferences';
import LoadingSpinner from '../../../shared/js/components/LoadingSpinner';
import _ from 'lodash';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import 'moment-timezone';
import { Link } from 'react-router';
import { pluralize } from '../../../a2i/js/lib/stringFormatter';

let preferences = new Preferences(localStorage);

let ReliabilityObservationSetup = React.createClass({
	propTypes: {
		createObservation: PropTypes.func.isRequired,
		isFetchingObservations: PropTypes.bool,
		observations: PropTypes.array,
		router: PropTypes.object.isRequired,
	},

	getInitialState: function() {
		return {
			goldStandardObservation: null,
			isCreatingObservation: false,
		};
	},

	minimumMinutesSinceLastObservation: 1440,

	handleSubmit: function(ev) {
		ev.preventDefault();

		let { goldStandardObservation } = this.state;

		let observation = {
			classroom: goldStandardObservation.classroom,
			classroom_id: goldStandardObservation.classroom.id,
			number_of_cycles: goldStandardObservation.number_of_cycles,
			observation_date: goldStandardObservation.observation_date,
			student_ids: goldStandardObservation.students.map((student) => student.id),
			student_minutes: goldStandardObservation.student_minutes,
			students: goldStandardObservation.students,
			teacher: goldStandardObservation.teacher,
			teacher_id: goldStandardObservation.teacher.id,
			teacher_minutes: goldStandardObservation.teacher_minutes,
			gold_standard_observation_id: goldStandardObservation.id
		};

		this.props.createObservation(observation);
		this.props.router.push('/observations/current');
	},

	getGoldStandards: function() {
		if (this.props.observations && this.props.observations.length) {
			return this.props.observations.asMutable().filter((observation) => {
				return observation.is_gold_standard;
			});
		} else {
			return [];
		}
	},

	handleSelectObservation: function(observation) {
		if (this.isSelected(observation)) {
			this.setState({ goldStandardObservation: null });
		} else {
			this.setState({ goldStandardObservation: observation });
		}
	},

	isSelected: function(observation) {
		return JSON.stringify(this.state.goldStandardObservation) === JSON.stringify(observation);
	},

	render: function() {
		let { observations } = this.props,
			{ goldStandardObservation } = this.state,
			goldStandardObservations = this.getGoldStandards();

		return(
			<div className="reliability-observation-setup container">
				<h2>Reliability Observation</h2>
				<p>Select a gold standard observation to repeat from the list below.</p>
				{
					this.props.isFetchingObservations ? (
						<span>Loading... <LoadingSpinner /></span>
					) : (
						// SELECT GOLD STANDARD
						observations && observations.length ? (
							goldStandardObservations.length === 0 ? (
								<div className="none-found">
									Before performing a reliability observation, you&apos;ll need to specify some observations as gold standards.  <Link to="/standards">Click here to do that!</Link>
								</div>
							) : (
								<table className="table table-striped table-condensed gold-standard-observations-table">
									<thead>
										<tr>
											<th></th>
											<th>ID</th>
											<th>District</th>
											<th>School</th>
											<th>Classroom</th>
											<th>Instruction Date</th>
											<th>Coding Date</th>
										</tr>
									</thead>
									<tbody>
										{
											goldStandardObservations.map((observation) => {
												return (
													<tr
														className={ this.isSelected(observation) ? 'active' : '' }
														style={ { cursor: 'pointer' } }
														onClick={ () => {
															this.handleSelectObservation(observation);
														} }
														key={ observation.id }
													>
														<td>
															{
																<button
																	className={ 'btn btn-sm ' + (
																		this.isSelected(observation) ? 'btn-success active' : 'btn-default'
																	) }
																	onClick={ () => {
																		this.handleSelectObservation(observation);
																	} }
																>
																	Select
																</button>
															}
														</td>
														<td>{ observation.id }</td>
														<td>{ observation.district_name }</td>
														<td>{ observation.school_name }</td>
														<td>{ observation.classroom.description }</td>
														<td>{ moment(observation.observation_date).format('YYYY-MM-DD') }</td>
														<td>{ moment(observation.created_at).format('YYYY-MM-DD') }</td>
													</tr>
												);
											})
										}
									</tbody>
								</table>
							)
						) : (
							<div className="no-observations-found">
								No completed observations were found.
							</div>
						)
					)
				}
				{
					goldStandardObservation ? (
						<div className="observation-parameters">
							<div className="total-minutes">
								This observation will last { (goldStandardObservation.student_minutes + goldStandardObservation.teacher_minutes) * goldStandardObservation.number_of_cycles } minutes total.  There will be { pluralize(goldStandardObservation.number_of_cycles, 'cycle') } of { goldStandardObservation.student_minutes } student minutes and { goldStandardObservation.teacher_minutes } teacher minutes.
							</div>

							<div className="observation-parameter selected-students">
								<span className="parameter-name">
									You will observe { pluralize(goldStandardObservation.students.length, 'student') }:
								</span>
								<ol>
									{
										this.state.goldStandardObservation.students.asMutable().map((student) => {
											return (
												<li key={ student.id }>{ student.last_name + ', ' + student.first_name }</li>
											);
										})
									}
								</ol>
							</div>

							<button
								className="btn btn-lg btn-primary start-observation"
								onClick={ this.handleSubmit }
								disabled={ this.state.isCreatingObservation }
							>
								{
									this.state.isCreatingObservation ? (
										<span>
											<i className="glyphicon glyphicon-refresh glyphicon-spin" />
											{' '}
											Loading
										</span>
									) : (
										<span>
											Start
										</span>
									)
								}
							</button>
						</div>
					) : ''
				}
			</div>
		);
	}
});

module.exports = ReliabilityObservationSetup;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/ReliabilityObservationSetup.jsx